import api from "services/api";

// Fetch list of employees specifically for the Role Assignment view
export const getEmployeesForRoleAssignment = async () => {
  return api.get("/v1/api/employees/list");
};

// Fetch list of roles to show in the assignment dropdown
export const getRolesForAssignment = async () => {
  return api.get("/v1/api/get-role-list-with-permissions?filterTaken=true");
};

// Assign role to employee
export const assignRoleEmployee = async (payload) => {
  return api.post("/v1/api/assign-role-to-employee", payload);
};
